import { DESTINATIONS, type TabDirection } from "./tabs";
export const TAB_LOCK_PX = 12;
export const TAB_AXIS_RATIO = 1.5;
export const TAB_EDGE_PX = 28;
export const TAB_PHONE_WIDTH = 768;
export const TAB_MIN_COMMIT_PX = 80;
export const TAB_COMMIT_SHARE = 0.28;
export function tabThreshold(width: number): number { return Math.max(TAB_MIN_COMMIT_PX, Math.round(width * TAB_COMMIT_SHARE)); }
export const TAB_FLICK_PX = 40;
export const TAB_FLICK_SPEED = 0.5;
export const TAB_PEEK_RESISTANCE = 0.25;
export const TAB_END_RESISTANCE = 0.1;
export function tabRootOf(path: string): string | null { return DESTINATIONS.find(tab => tab.to === path)?.to ?? null; }
export function neighbourTab(path: string, direction: TabDirection): string | null {
  const index = DESTINATIONS.findIndex(tab => tab.to === path);
  return index < 0 ? null : DESTINATIONS[index + (direction === "forward" ? 1 : -1)]?.to ?? null;
}
export function tabAxis(dx: number, dy: number): "x" | "y" | null {
  if (Math.max(Math.abs(dx), Math.abs(dy)) < TAB_LOCK_PX) return null;
  return Math.abs(dx) >= TAB_AXIS_RATIO * Math.abs(dy) ? "x" : "y";
}
export function tabCommit(dx: number, width: number, elapsed: number): boolean {
  return Math.abs(dx) >= tabThreshold(width) ||
    (Math.abs(dx) >= TAB_FLICK_PX && Math.abs(dx) / Math.max(1, elapsed) >= TAB_FLICK_SPEED);
}
export function tabOffset(dx: number, hasNeighbour: boolean): number { return dx * (hasNeighbour ? TAB_PEEK_RESISTANCE : TAB_END_RESISTANCE); }
export function tabEligible(state: { path: string; pointerType: string; width: number; x: number; dialog: boolean; selecting: boolean; routeRoot: boolean }): boolean {
  return state.routeRoot && state.pointerType === "touch" && state.width < TAB_PHONE_WIDTH && tabRootOf(state.path) !== null && !state.dialog && !state.selecting && state.x >= TAB_EDGE_PX && state.x <= state.width - TAB_EDGE_PX;
}
